import { createSelector } from "@ngrx/store";
import { RootSelectors } from "../app.selector";


export const CountrySelectors = {
    COUNTRIES: createSelector(RootSelectors.REFERENCE_DATA, (data) => data.countries)
}
